import { GetNationalityPayload } from "app/services/payloadSubmit/getNationalityPayload";
import { CAPS_LOCK_WARNING } from "constants/settings";
import { config } from "utilities/config";
export const getNationalitySchema = {
  title: "Edit Contact",
  logicalname: "Contact2",
  type: "object",
  additionalDescription: CAPS_LOCK_WARNING,
  properties: {
    ctpt_nationalityid: {
      title: "Nationalities",
      type: "string",
      datatype: "array",
      enum: [],
      enumNames: [],
      isDynamic: true,
      payload: GetNationalityPayload,
      apiURL: config.teleportal.submitForm.get,
    }
  }
};
